import { Select } from "antd";
import { IconArrowDown } from "@icons/index";
import { TestId } from "@shared/testIds";
import { VIDEO_SPECS_SELECT_CLASS } from "./constants";
import type { SpecsSelectProps, VideoSpecsOption } from "./types";

interface ResolutionSelectProps extends SpecsSelectProps {
  value: string;
  options: VideoSpecsOption<string>[];
  onChange: (value: string) => void;
}

export function ResolutionSelect({ value, options, disabled, onChange }: ResolutionSelectProps) {
  return (
    <Select
      size="large"
      disabled={disabled}
      data-testid={TestId.VideoResolutionSelect}
      value={value && options.some((option) => option.value === value) ? value : options[0]?.value}
      onChange={onChange}
      options={options}
      className={VIDEO_SPECS_SELECT_CLASS}
      popupMatchSelectWidth={false}
      suffixIcon={<IconArrowDown className="h-[16px] w-[16px] text-kds-fg-subtle" />}
    />
  );
}
